/**
 * @fileoverview Atom: amortisation progress.
 * @module components/atoms/ProgressBar
 */

import "./ProgressBar.css"

/** Props accepted by {@link ProgressBar}. */
export interface ProgressBarProps {
	/** Progress between 0 and 1. Values outside the range are clamped. */
	readonly ratio: number
	/** Description announced to assistive technology. */
	readonly label: string
}

/**
 * Horizontal progress indicator.
 *
 * @param props - Ratio and accessible label.
 * @returns The rendered bar, exposed as a native progressbar.
 */
export function ProgressBar({ ratio, label }: ProgressBarProps) {
	const clamped = Math.min(1, Math.max(0, ratio))
	const percent = Math.round(clamped * 100)

	return (
		<div
			className={`progress${clamped >= 1 ? " progress--done" : ""}`}
			role="progressbar"
			aria-valuenow={percent}
			aria-valuemin={0}
			aria-valuemax={100}
			aria-label={label}
		>
			<div
				className="progress__fill"
				style={{ width: `${String(percent)}%` }}
			/>
		</div>
	)
}
